exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachment[data-v-4bf4dd66]{width:12.5rem;height:11.25rem;border-radius:.625rem;object-fit:cover}", ""]);

// exports
